export enum EProjectTypeName {
  BUILDING = 'Building',
  CIVIL = 'Civil',
  FOUNDATIONS = 'Foundations',
  E_AND_M = 'E&M',
  CONCRETE = 'Concrete',
  STEELWORK = 'Steelwork',
  TENDER = 'Tender',
}
